export default __webpack_public_path__ + "static/media/banner_header_soporte.6182c354.jpg";